import React, { useState, useEffect, useRef } from 'react';

// Hauptkomponente der Anwendung
const App = () => {
  // Beispiel-Aufgussdaten mit Intensität, Musik, Temperatur, Sauna-Namen, Beschreibung und Ausführendem
  const [infusions, setInfusions] = useState([
    { id: '1', time: '09:00', title: 'Morgenfrische', description: 'Belebender Start mit Eukalyptus-Duft.', performer: 'Saunameister Max', intensity: 'Mild', music: 'Leise', temperature: '80°C', saunaName: 'Maximus' },
    { id: '2', time: '09:30', title: 'Kräuterwiese', description: 'Entspannender Aufguss mit frischen Gartenkräutern.', performer: 'Saunameisterin Lisa', intensity: 'Mittel', music: 'Mittel', temperature: '85°C', saunaName: 'Kristall' },
    { id: '3', time: '10:00', title: 'Fruchtcocktail', description: 'Erfrischend und belebend mit Zitrusnoten.', performer: 'Saunameister Tom', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Baumhaus' },
    { id: '4', time: '10:30', title: 'Waldspaziergang', description: 'Duft von Tannen und Moos für tiefe Entspannung.', performer: 'Saunameisterin Anna', intensity: 'Mittel', music: 'Leise', temperature: '80°C', saunaName: 'Jägersauna' },
    { id: '5', time: '11:00', title: 'Schoko-Minze Traum', description: 'Ein süßer und erfrischender Genuss.', performer: 'Saunameister Max', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Orangensauna' },
    { id: '6', time: '11:30', title: 'Abendrot', description: 'Beruhigender Aufguss zum Ausklang des Tages.', performer: 'Saunameisterin Lisa', intensity: 'Stark', music: 'Mittel', temperature: '90°C', saunaName: 'Banjasauna' },
    { id: '7', time: '12:00', title: 'Gute Nacht', description: 'Sanfter Aufguss für einen erholsamen Schlaf.', performer: 'Saunameister Tom', intensity: 'Mittel', music: 'Leise', temperature: '85°C', saunaName: 'Maximus' },
    { id: '8', time: '12:30', title: 'Sternenhimmel', description: 'Ein meditativer Aufguss mit Lavendel.', performer: 'Saunameisterin Anna', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Kristall' },
    { id: '9', time: '13:00', title: 'Traumreise', description: 'Ein letzter Aufguss für süße Träume.', performer: 'Saunameister Max', intensity: 'Mittel', music: 'Mittel', temperature: '80°C', saunaName: 'Baumhaus' },
    { id: '10', time: '13:30', title: 'Exotische Früchte', description: 'Ein belebender Aufguss mit tropischen Düften.', performer: 'Saunameisterin Lisa', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Jägersauna' },
    { id: '11', time: '14:00', title: 'Alpenkräuter', description: 'Erfrischend und klärend mit Bergkräutern.', performer: 'Saunameister Tom', intensity: 'Mittel', music: 'Leise', temperature: '85°C', saunaName: 'Orangensauna' },
    { id: '12', time: '14:30', title: 'Zitrus-Explosion', description: 'Belebend mit frischen Zitrusaromen.', performer: 'Saunameisterin Anna', intensity: 'Stark', music: 'Mittel', temperature: '90°C', saunaName: 'Banjasauna' },
    { id: '13', time: '15:00', title: 'Honig-Milch', description: 'Sanft und pflegend für die Haut.', performer: 'Saunameister Max', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Maximus' },
    { id: '14', time: '15:30', title: 'Eisminze', description: 'Kühlend und erfrischend nach einem langen Tag.', performer: 'Saunameisterin Lisa', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Kristall' },
    { id: '15', time: '16:00', title: 'Rose Garden', description: 'Romantischer Aufguss mit Rosenduft.', performer: 'Saunameister Tom', intensity: 'Mittel', music: 'Leise', temperature: '80°C', saunaName: 'Baumhaus' },
    { id: '16', time: '16:30', title: 'Meeresbrise', description: 'Belebend wie ein Spaziergang am Meer.', performer: 'Saunameisterin Anna', intensity: 'Mild', music: 'Mittel', temperature: '85°C', saunaName: 'Jägersauna' },
    { id: '17', time: '17:00', title: 'Ingwer-Limette', description: 'Würzig und erfrischend zugleich.', performer: 'Saunameister Max', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Orangensauna' },
    { id: '18', time: '17:30', title: 'Lavendeltraum', description: 'Beruhigend und entspannend für die Seele.', performer: 'Saunameisterin Lisa', intensity: 'Mittel', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Banjasauna' },
    { id: '19', time: '18:00', title: 'Schwarzwald-Kiefer', description: 'Erdig und wohltuend mit Nadelholzduft.', performer: 'Saunameister Tom', intensity: 'Mild', music: 'Leise', temperature: '80°C', saunaName: 'Maximus' },
    { id: '20', time: '18:30', title: 'Orientalische Nacht', description: 'Geheimnisvoll und wärmend mit Gewürzen.', performer: 'Saunameisterin Anna', intensity: 'Stark', music: 'Mittel', temperature: '90°C', saunaName: 'Kristall' },
    { id: '21', time: '19:00', title: 'Kamille pur', description: 'Sanft und beruhigend für den Abend.', performer: 'Saunameister Max', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Baumhaus' },
    { id: '22', time: '19:30', title: 'Feuer und Eis', description: 'Kontrastreich und belebend.', performer: 'Saunameisterin Lisa', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Jägersauna' },
    { id: '23', time: '20:00', title: 'Mondscheinmelodie', description: 'Ein ruhiger Aufguss zum Tagesausklang.', performer: 'Saunameister Tom', intensity: 'Mittel', music: 'Leise', temperature: '80°C', saunaName: 'Orangensauna' },
    { id: '24', time: '20:30', title: 'Schlaf gut', description: 'Spezialaufguss für eine erholsame Nacht.', performer: 'Saunameisterin Anna', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Banjasauna' },
    { id: '25', time: '21:00', title: 'Abschlusszauber', description: 'Der letzte Aufguss des Tages.', performer: 'Saunameister Max', intensity: 'Stark', music: 'Mittel', temperature: '90°C', saunaName: 'Maximus' },
    { id: '26', time: '21:30', title: 'Minz-Kick', description: 'Erfrischender Aufguss mit belebender Minze.', performer: 'Saunameisterin Lara', intensity: 'Mittel', music: 'Leise', temperature: '85°C', saunaName: 'Kristall' },
    { id: '27', time: '22:00', title: 'Sandelholz-Traum', description: 'Warmer, erdiger Duft für tiefe Entspannung.', performer: 'Saunameister Ben', intensity: 'Mild', music: 'Ohne Musik', temperature: '75°C', saunaName: 'Baumhaus' },
    { id: '28', time: '22:30', title: 'Zimt-Apfel', description: 'Süßlicher und wärmender Aufguss für die Sinne.', performer: 'Saunameisterin Clara', intensity: 'Mittel', music: 'Mittel', temperature: '80°C', saunaName: 'Jägersauna' },
    { id: '29', time: '23:00', title: 'Gletscherwind', description: 'Intensiv kühlender Aufguss für Mutige.', performer: 'Saunameister Max', intensity: 'Stark', music: 'Laut', temperature: '90°C', saunaName: 'Orangensauna' },
    { id: '30', time: '23:30', title: 'Morgenröte', description: 'Sanfter Ausklang mit beruhigenden Aromen.', performer: 'Saunameisterin Lisa', intensity: 'Mild', music: 'Leise', temperature: '75°C', saunaName: 'Banjasauna' },
  ]);

  // Beispiel für zusätzliche Informationen
  const [additionalInfo, setAdditionalInfo] = useState([
    { id: 'info1', message: 'Heute Abend: Grillen am Seehaus ab 18:00 Uhr!', active: true },
    { id: 'info3', message: 'Sonderaufguss um 20:00 Uhr: Eisminze-Explosion!', active: true },
  ]);

  const [currentTime, setCurrentTime] = useState(new Date());

  // Refs für die Tagesübersicht (nicht mehr für Paginierung, sondern für Layout)
  const dailyOverviewListRef = useRef(null);

  // Effekt zum Aktualisieren der Uhrzeit jede Sekunde
  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timerId); // Cleanup bei Komponenten-Unmount
  }, []);

  // Funktion zum Ermitteln der nächsten Aufgüsse
  const getUpcomingInfusions = (now, allInfusions) => {
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const upcoming = [];

    for (const infusion of allInfusions) {
      const [hour, minute] = infusion.time.split(':').map(Number);
      const infusionMinutes = hour * 60 + minute;

      // Berücksichtige nur Aufgüsse, die noch nicht vorbei sind (mit 15 Minuten Puffer)
      if (infusionMinutes >= currentMinutes - 15) {
        upcoming.push({ ...infusion, minutesUntil: infusionMinutes - currentMinutes });
      }
    }

    // Sortiere nach Zeit und nimm die nächsten 3
    return upcoming
      .sort((a, b) => a.minutesUntil - b.minutesUntil)
      .filter(infusion => infusion.minutesUntil >= -15) // Filtert Aufgüsse, die zu weit in der Vergangenheit liegen
      .slice(0, 3); // Zeigt die nächsten 3 Aufgüsse
  };

  const upcomingInfusions = getUpcomingInfusions(currentTime, infusions);

  // Findet den aktuell laufenden Aufguss (innerhalb der letzten 15 Minuten)
  const currentRunningInfusion = infusions.find(infusion => {
    const [hour, minute] = infusion.time.split(':').map(Number);
    const infusionMinutes = hour * 60 + minute;
    const currentMinutes = currentTime.getHours() * 60 + currentTime.getMinutes();
    return currentMinutes >= infusionMinutes && currentMinutes < infusionMinutes + 15; // Angenommen 15 Min Dauer
  });

  // Filtert Aufgüsse für die Tagesübersicht (ohne die bereits in "Nächste Aufgüsse" angezeigten)
  const getDailyOverviewInfusions = (now, allInfusions, upcoming) => {
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const upcomingInfusionIds = new Set(upcoming.map(inf => inf.id)); // IDs der bereits angezeigten Aufgüsse

    // Ermittle die Zeit des ersten Aufgusses
    const firstInfusionTime = allInfusions.length > 0
      ? allInfusions[0].time.split(':').map(Number)[0] * 60 + allInfusions[0].time.split(':').map(Number)[1]
      : 0; // Wenn keine Aufgüsse, dann 0

    let filteredInfusions;

    // Wenn die aktuelle Zeit vor dem ersten Aufguss des Tages liegt, zeige alle Aufgüsse
    if (currentMinutes < firstInfusionTime) {
      filteredInfusions = allInfusions;
    } else {
      // Ansonsten filtere abgelaufene Aufgüsse (die vor mehr als 15 Minuten beendet wurden)
      filteredInfusions = allInfusions.filter(infusion => {
        const [hour, minute] = infusion.time.split(':').map(Number);
        const infusionMinutes = hour * 60 + minute;
        // Zeige Aufgüsse, die noch nicht vorbei sind oder gerade laufen
        return infusionMinutes >= currentMinutes - 15;
      });
    }

    // Zusätzliches Filtern, um Aufgüsse zu entfernen, die bereits in der "Nächste Aufgüsse" Liste sind
    return filteredInfusions.filter(infusion => !upcomingInfusionIds.has(infusion.id));
  };

  const dailyOverviewInfusions = getDailyOverviewInfusions(currentTime, infusions, upcomingInfusions);


  // CSS-Styles für die React-Komponenten (eingebettet)
  const styles = `
    body {
      margin: 0;
      font-family: 'Inter', sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      background: linear-gradient(to bottom right, #e0f7fa, #bbdefb); /* Miramar-inspirierter Hintergrund */
      font-size: 16px; /* Basis-Schriftgröße für Full HD - angepasst */
      height: 100vh; /* Sicherstellen, dass der Body die volle Viewport-Höhe einnimmt */
      overflow: hidden; /* Verhindert Scrollbalken auf Body-Ebene */
    }

    .app-container {
      min-height: 100vh; /* Sicherstellen, dass der Container die volle Viewport-Höhe einnimmt */
      background: linear-gradient(to bottom right, #e0f7fa, #bbdefb); /* Miramar-inspirierter Hintergrund */
      color: #333;
      padding: 15px; /* Angepasst für Kompaktheit */
      display: flex;
      flex-direction: column;
      align-items: center;
      font-family: 'Inter', sans-serif;
      box-sizing: border-box; /* Padding in die Höhe einbeziehen */
    }

    /* Header */
    .app-header {
      width: 100%;
      max-width: 1800px; /* Angepasst für Full HD */
      display: flex;
      flex-direction: column; /* Standard auf Spalte für kleinere Bildschirme */
      align-items: center;
      justify-content: space-between;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 16px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      padding: 8px 15px; /* Stark reduziertes Padding */
      margin-bottom: 15px; /* Reduzierter Abstand nach unten */
      border: 2px solid #81d4fa;
      gap: 8px; /* Reduzierter Abstand zwischen den Header-Elementen */
      box-sizing: border-box;
    }

    @media (min-width: 1024px) { /* Auf größeren Bildschirmen, als Reihe */
      .app-header {
        flex-direction: row;
        align-items: center; /* Vertikale Ausrichtung in der Mitte */
        justify-content: space-between; /* Elemente verteilen */
        gap: 8px; /* Reduzierter Abstand zwischen den Hauptblöcken im Header */
      }
    }

    .header-left {
      display: flex;
      flex-direction: column;
      align-items: center; /* Titel auf kleinen Bildschirmen zentrieren */
      flex-shrink: 0; /* Verhindert Schrumpfen */
      justify-content: center; /* Vertikale Zentrierung */
    }

    @media (min-width: 1024px) {
      .header-left {
        align-items: flex-start; /* Titel auf großen Bildschirmen links ausrichten */
      }
    }

    .header-right {
      display: flex;
      flex-direction: column; /* Uhrzeit/Infos auf kleinen Bildschirmen zentrieren */
      align-items: center;
      gap: 6px; /* Reduzierter Abstand */
      flex-grow: 1; /* Nimmt verfügbaren Platz ein */
      justify-content: center; /* Vertikale Zentrierung */
    }

    @media (min-width: 1024px) {
      .header-right {
        flex-direction: row; /* Uhrzeit und Infos nebeneinander */
        justify-content: space-between; /* Elemente verteilen sich */
        align-items: center;
        gap: 8px; /* Reduzierter Abstand zwischen Uhrzeit und Info-Container */
      }
    }

    .header-info-container {
      display: flex;
      flex-direction: column; /* Info-Karten stapeln */
      gap: 6px; /* Reduzierter Abstand zwischen Info-Karten */
      width: 100%; /* Volle Breite des Eltern-Containers */
      text-align: center; /* Info-Text zentrieren */
      flex-wrap: wrap; /* Umbruch erlauben, wenn viele Info-Karten */
      justify-content: center; /* Zentriert die Info-Karten horizontal */
      flex-grow: 1; /* Nimmt verfügbaren Platz ein, um mittig zu sein */
    }

    @media (min-width: 768px) { /* Anpassung für breitere Mobil-/Tablet-Ansicht */
      .header-info-container {
        flex-direction: row; /* Info-Karten in einer Reihe anordnen */
      }
    }

    @media (min-width: 1024px) {
      .header-info-container {
        /* justify-content: center; /* Entfernt, da space-between im Elternteil */
        flex-grow: 1; /* Nimmt restlichen Platz ein */
      }
    }

    .app-title {
      font-size: 2.8rem; /* Weiter reduziert */
      font-weight: bolder;
      color: #0056b3; /* Dunklerer Miramar-Blau */
      margin: 0; /* Alle Margins auf 0 setzen */
      padding: 0; /* Alle Paddings auf 0 setzen */
      line-height: 1; /* Sicherstellen, dass die Zeilenhöhe keine zusätzlichen Abstände erzeugt */
    }

    .app-time {
      font-size: 2.4rem; /* Weiter reduziert */
      font-weight: bold;
      color: #007BFF; /* Miramar-Blau */
      flex-shrink: 0; /* Verhindert Schrumpfen */
      order: 2; /* Uhrzeit nach den Infos */
      margin: 0; /* Alle Margins auf 0 setzen */
      padding: 0; /* Alle Paddings auf 0 setzen */
      line-height: 1; /* Sicherstellen, dass die Zeilenhöhe keine zusätzlichen Abstände erzeugt */
    }

    @media (min-width: 1024px) {
      .app-time {
        order: 2; /* Bleibt rechts */
      }
      .header-info-container {
        order: 1; /* Infos links von der Uhrzeit */
      }
    }


    /* Main Grid Layout */
    .main-grid {
      width: 100%;
      max-width: 1800px; /* Angepasst für Full HD */
      display: grid;
      grid-template-columns: 1fr 3fr; /* Geändert auf 1/4 und 3/4 */
      gap: 20px; /* Reduzierter Abstand */
      flex-grow: 1; /* Lässt das Grid den verbleibenden Platz einnehmen */
      box-sizing: border-box;
    }

    /* Responsive für kleinere Bildschirme (z.B. Tablets/Laptops), falls doch mal nötig */
    @media (max-width: 1024px) {
      .main-grid {
        grid-template-columns: 1fr; /* Eine Spalte für kleinere Ansichten */
      }
    }

    .grid-column {
      grid-column: span 1;
      background-color: rgba(255, 255, 255, 0.95);
      border-radius: 16px;
      box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.1), 0 3px 6px -2px rgba(0, 0, 0, 0.08);
      padding: 15px; /* Reduziertes Padding */
      border: 2px solid #81d4fa;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    .column-title {
      font-size: 2.2rem; /* Reduziert */
      font-weight: bold;
      color: #007BFF;
      margin-bottom: 15px; /* Reduziert */
      text-align: center;
    }

    .current-infusion-banner {
      background-color: #e6ffe6;
      border-left: 5px solid #28a745;
      color: #1a5e20;
      padding: 12px; /* Reduziert */
      border-radius: 8px;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.08);
      margin-bottom: 15px; /* Reduziert */
      animation: pulse 2s infinite;
    }

    .current-infusion-text {
      font-weight: 600;
      font-size: 1.3rem; /* Reduziert */
    }

    .current-infusion-label {
      color: #28a745;
    }

    .infusion-list-container {
      display: flex;
      flex-direction: column;
      gap: 6px; /* Reduziert */
      flex-grow: 1; /* Lässt die Liste den verbleibenden Platz einnehmen */
      overflow: hidden; /* Verhindert Scrollbalken in der Liste selbst */
      justify-content: flex-start; /* Wichtig: Elemente oben stapeln, nicht verteilen */
      transition: opacity 0.5s ease-in-out; /* Transition für Opacity */
    }

    .daily-overview-list {
      display: grid; /* Geändert auf Grid-Layout */
      grid-template-columns: repeat(2, 1fr); /* Geändert auf 2 Spalten */
      gap: 6px; /* Abstand zwischen Kacheln */
      overflow-y: auto; /* Fallback-Scroll, falls nicht alles passt */
      height: 100%; /* Nimmt die verfügbare Höhe der Spalte ein */
      box-sizing: border-box;
      padding-right: 5px; /* Platz für Scrollbar */
      transition: none; /* Keine Opacity-Transition hier, da Paging entfernt */
      align-content: flex-start; /* Kacheln oben ausrichten */
    }

    /* Custom scrollbar for daily-overview-list */
    .daily-overview-list::-webkit-scrollbar {
      width: 6px; /* Dünne Scrollbar */
    }
    .daily-overview-list::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }
    .daily-overview-list::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 3px;
    }
    .daily-overview-list::-webkit-scrollbar-thumb:hover {
      background: #777;
    }

    .no-infusions-message {
      text-align: center;
      color: #6b7280;
      font-size: 1.3rem; /* Reduziert */
      flex-grow: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .info-column {
      grid-column: span 1;
      display: flex;
      flex-direction: column;
      gap: 25px;
    }

    /* InfusionCard spezifisches CSS */
    .infusion-card {
      background-color: #ffffff;
      border-radius: 8px;
      padding: 8px 10px; /* Reduziertes Padding */
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease-in-out;
      border: 1px solid #e0e0e0;
      flex-shrink: 0; /* Verhindert Schrumpfen in Flexbox */
    }

    .infusion-card-highlight {
      border: 3px solid #007BFF;
      transform: scale(1.02);
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
    }

    .infusion-card-past {
      opacity: 0.6;
    }

    .infusion-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2px; /* Reduziert */
    }

    .infusion-title {
      font-size: 1.1rem; /* Reduziert */
      font-weight: bold;
      color: #0056b3;
      display: flex; /* Für Inline-Sauna-Name */
      align-items: baseline;
      gap: 6px; /* Reduziert */
    }

    .infusion-sauna-name-inline { /* Neuer Stil für Inline-Sauna-Name */
      font-size: 0.95rem; /* Reduziert */
      font-weight: normal; /* Weniger prominent als Titel */
      color: #6c757d;
      white-space: nowrap; /* Verhindert Zeilenumbruch */
    }

    .infusion-time {
      font-size: 1.3rem; /* Reduziert */
      font-weight: bolder;
      color: #007BFF;
    }

    .infusion-description { /* Beschreibung wieder eingeführt */
      color: #4b5563;
      margin-bottom: 6px; /* Reduziert */
      font-size: 0.9rem; /* Reduziert */
    }

    .infusion-details {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 4px; /* Reduziert */
      font-size: 0.95rem; /* Reduziert */
    }

    .infusion-temperature,
    .infusion-intensity,
    .infusion-music {
      display: flex;
      align-items: center;
      color: #4b5563;
    }

    .infusion-temperature span,
    .infusion-intensity span,
    .infusion-music span {
      white-space: nowrap;
    }

    .intensity-dot {
      width: 8px; /* Reduziert */
      height: 8px; /* Reduziert */
      border-radius: 50%;
      margin-right: 3px; /* Reduziert */
      margin-left: 5px; /* Reduziert */
    }

    .intensity-mild { background-color: #28a745; }
    .intensity-medium { background-color: #ffc107; }
    .intensity-strong { background-color: #dc3545; }
    .intensity-default { background-color: #9ca3af; }

    .infusion-status-container {
      margin-top: 2px; /* Reduziert */
      text-align: right;
    }

    .infusion-status {
      font-size: 1rem; /* Reduziert */
    }

    .status-default { color: #4b5563; }
    .status-running { color: #28a745; font-weight: bold; }
    .status-soon { color: #fd7e14; font-weight: bold; }
    .status-past { color: #6c757d; text-decoration: line-through; }

    /* InfoCard spezifisches CSS (angepasst für Header-Platzierung) */
    .info-card {
      background-color: #fff3cd;
      border-radius: 8px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
      padding: 6px 10px; /* Stark reduziertes Padding */
      border: 1px solid #ffeeba;
      text-align: center;
      flex-shrink: 0;
    }

    .info-card-message {
      font-size: 1rem; /* Reduziert */
      color: #856404;
      margin: 0; /* Entfernt Margins */
      padding: 0; /* Entfernt Paddings */
    }

    /* Specific styles for cards in the daily overview to make them more compact */
    .infusion-card.daily-overview-compact {
      padding: 6px 8px; /* Slightly increased padding for larger fonts */
    }
    .infusion-card.daily-overview-compact .infusion-header {
      margin-bottom: 2px; /* Adjusted margin */
    }
    .infusion-card.daily-overview-compact .infusion-title {
      font-size: 1.1rem; /* Increased title font size */
      gap: 5px;
    }
    .infusion-card.daily-overview-compact .infusion-sauna-name-inline {
      font-size: 0.95rem; /* Increased inline sauna name font size */
    }
    .infusion-card.daily-overview-compact .infusion-time {
      font-size: 1.2rem; /* Increased time font size */
    }
    .infusion-card.daily-overview-compact .infusion-description {
      display: none; /* Hide description for compact view */
    }
    .infusion-card.daily-overview-compact .infusion-details {
      font-size: 0.9rem; /* Increased details font size */
      margin-top: 2px; /* Adjusted margin */
    }
    .infusion-card.daily-overview-compact .intensity-dot {
      width: 8px;
      height: 8px;
      margin-right: 3px;
      margin-left: 5px;
    }
    .infusion-card.daily-overview-compact .infusion-status-container {
      margin-top: 2px; /* Adjusted margin */
    }
    .infusion-card.daily-overview-compact .infusion-status {
      font-size: 1rem; /* Increased status font size */
    }

    /* Animation */
    @keyframes pulse {
      0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7); }
      70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
      100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
    }
  `;

  // Fügen Sie die Styles in den DOM ein
  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);
    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  return (
    <div className="app-container">
      {/* Kopfbereich mit Uhrzeit und Titel */}
      <header className="app-header">
        <div className="header-left">
          <h1 className="app-title">Sauna Aufgussplan</h1>
        </div>
        <div className="header-right">
          {/* Container für Info-Karten (mittig) */}
          <div className="header-info-container">
            {additionalInfo.filter(info => info.active).map(info => (
              <InfoCard key={info.id} message={info.message} />
            ))}
          </div>
          {/* Uhrzeit (rechter Rand) */}
          <div className="app-time">
            {currentTime.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })}
          </div>
        </div>
      </header>

      {/* Hauptinhalt - Grid-Layout für TV-Anzeige */}
      <main className="main-grid">
        {/* Linke Spalte: Nächste Aufgüsse (1/4 Breite) */}
        <section className="grid-column">
          <h2 className="column-title">Nächste Aufgüsse</h2>
          {currentRunningInfusion && (
            <div className="current-infusion-banner">
              <p className="current-infusion-text">
                <span className="current-infusion-label">Aktuell läuft:</span> {currentRunningInfusion.title} ({currentRunningInfusion.time})
              </p>
            </div>
          )}
          {upcomingInfusions.length > 0 ? (
            <div className="infusion-list-container upcoming-list">
              {upcomingInfusions.map((infusion, index) => (
                <InfusionCard
                  key={infusion.id}
                  infusion={infusion}
                  isHighlight={index === 0 && !currentRunningInfusion}
                  currentTime={currentTime}
                  showDescription={true} // Beschreibung hier anzeigen
                />
              ))}
            </div>
          ) : (
            <p className="no-infusions-message">Heute sind keine weiteren Aufgüsse geplant.</p>
          )}
        </section>

        {/* Rechte Spalte: Alle Aufgüsse des Tages (3/4 Breite) */}
        <section className="grid-column">
          <h2 className="column-title">Alle Aufgüsse des Tages</h2>
          <div
            className="infusion-list-container daily-overview-list"
            ref={dailyOverviewListRef}
          >
            {dailyOverviewInfusions.length > 0 ? (
              dailyOverviewInfusions.map(infusion => (
                <InfusionCard
                  key={infusion.id}
                  infusion={infusion}
                  isHighlight={false}
                  currentTime={currentTime}
                  showDescription={false} // Beschreibung hier NICHT anzeigen
                  isDailyOverview={true} // Spezifischer Stil für Tagesübersicht
                />
              ))
            ) : (
              <p className="no-infusions-message">Keine Aufgüsse für heute verfügbar.</p>
            )}
          </div>
        </section>
      </main>
    </div>
  );
};

// Komponente für eine einzelne Aufgusskarte
const InfusionCard = ({ infusion, isHighlight, currentTime, showDescription, isDailyOverview }) => {
  const [hour, minute] = infusion.time.split(':').map(Number);
  const infusionDate = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate(), hour, minute);
  const minutesUntil = Math.floor((infusionDate.getTime() - currentTime.getTime()) / (1000 * 60));

  let statusText = '';
  let statusColorClass = 'status-default';

  if (minutesUntil <= 0 && minutesUntil > -15) { // Angenommen 15 Min Dauer
    statusText = 'Läuft gerade!';
    statusColorClass = 'status-running';
  } else if (minutesUntil > 0 && minutesUntil <= 30) {
    statusText = `In ${minutesUntil} Min.`;
    statusColorClass = 'status-soon';
  } else if (minutesUntil < -15) { // Aufguss ist vorbei
    statusText = 'Vorbei';
    statusColorClass = 'status-past';
  } else {
    statusText = '';
    statusColorClass = 'status-default';
  }

  const cardClasses = `infusion-card ${isHighlight ? 'infusion-card-highlight' : ''} ${minutesUntil < -15 ? 'infusion-card-past' : ''} ${isDailyOverview ? 'daily-overview-compact' : ''}`;

  // Hilfsfunktion für Intensitätsanzeige
  const getIntensityColorClass = (level) => {
    const intensityMap = {
      'Mild': 'intensity-mild',
      'Mittel': 'intensity-medium',
      'Stark': 'intensity-strong'
    };
    return intensityMap[level] || 'intensity-default';
  };

  return (
    <div className={cardClasses}>
      <div className="infusion-header">
        {/* Sauna-Name direkt hinter dem Aufgussnamen */}
        <h3 className="infusion-title">
          {infusion.title} <span className="infusion-sauna-name-inline">({infusion.saunaName})</span>
        </h3>
        <span className="infusion-time">{infusion.time}</span>
      </div>
      {showDescription && infusion.description && ( // Beschreibung nur anzeigen, wenn showDescription true ist
        <p className="infusion-description">{infusion.description}</p>
      )}
      {showDescription && infusion.performer && ( // Performer anzeigen, wenn showDescription true ist
        <p className="infusion-description">Mit: {infusion.performer}</p>
      )}
      <div className="infusion-details">
        <div className="infusion-temperature">
          <span>Temp.:</span>
          <span>{infusion.temperature}</span>
        </div>
        <div className="infusion-intensity">
          <span>Intensität:</span>
          <div className={`intensity-dot ${getIntensityColorClass(infusion.intensity)}`}></div>
          <span>{infusion.intensity}</span>
        </div>
        <div className="infusion-music">
          <span>Musik:</span>
          <span>{infusion.music}</span>
        </div>
      </div>
      <div className="infusion-status-container">
        <span className={`infusion-status ${statusColorClass}`}>{statusText}</span>
      </div>
    </div>
  );
};

// Komponente für zusätzliche Informationskarten
const InfoCard = ({ message }) => {
  return (
    <div className="info-card">
      <p className="info-card-message">{message}</p>
    </div>
  );
};

// Export der Hauptkomponente
export default App;
